import { FormlyFieldConfig } from '@ngx-formly/core';
import { combineLatest, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { VehicleToGridInfo } from '@intellio/shared/models';
import { VehicleToGridInfoService } from '@intellio/shared/services';
import { getChildObject } from './form-data.utility';
import type { FormlyHookFn } from './formly-hook-fn.type';

export const filterVehicleToGridModelsHook = (
  vehicleToGridInfoService: VehicleToGridInfoService
): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    const parent = field.parent;
    const manufacturerField = getChildObject(parent, 'evseManufacturer');
    const manufacturerControl = parent.parent.formControl.get(manufacturerField.key);

    field.props.options = combineLatest([
      vehicleToGridInfoService.getVehicleToGridInfo().pipe(map((response) => response.data)),
      manufacturerControl.valueChanges.pipe(startWith(manufacturerControl.value)),
    ]).pipe(
      map(([records, manufacturer]: [VehicleToGridInfo[], string]) =>
        records
          .filter((record) => record.manufacturer === manufacturer)
          .map((record) => ({ value: record.modelNumber, label: record.modelNumber }))
      )
    );
  };
};
